<template>

    <section
        id="visit"
        class="visit"
        :style="backgroundStyle"
    >

        <div class="visit__overlay"></div>

        <div class="container">

            <div class="visit__content">

                <h2 class="visit__title">
                    {{ 'home_visit' | staticTitle }}
                </h2>

                <p class="visit__text">
                    {{ 'home_visit' | staticContent }}
                </p>

                <router-link
                    :to="{ path: '/', hash: '#contact' }"
                    class="visit__button"
                >
                    {{ 'home_visit_button' | staticTitle }}
                </router-link>

            </div>

        </div>

    </section>

</template>

<script>
export default {
    name: 'HomeVisit',

    computed: {
        backgroundStyle() {
            const image = this.$options.filters.staticImg('home_visit');

            return {
                backgroundImage: `url("${image}")`
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.visit {
    position: relative;

    width: 100%;

    min-height: 420px;

    display: flex;
    align-items: center;

    background-size: cover;
    background-position: center;

    overflow: hidden;

    &__overlay {
        position: absolute;

        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        background: linear-gradient(
            90deg,
            rgba(255, 255, 255, .85) 0%,
            rgba(255, 255, 255, .55) 40%,
            rgba(255, 255, 255, .05) 100%
        );
    }

    .container {
        position: relative;

        width: 100%;
        max-width: 500px;

        margin: 0 auto;
        padding: 60px 20px;

        z-index: 2;
    }

    &__content {
        max-width: 280px;
    }

    &__title {
        margin-bottom: 18px;

        font-family: 'Cormorant Garamond', serif;

        font-size: 2.2rem;
        font-weight: 700;

        line-height: 1;

        color: var(--text);
    }

    &__text {
        margin-bottom: 28px;

        font-family: 'Poppins', sans-serif;

        font-size: .95rem;

        line-height: 1.7;

        color: var(--text);
    }

    &__button {
        display: inline-flex;
        align-items: center;
        justify-content: center;

        padding: 14px 28px;

        background: var(--primary);
        color: var(--secondary);

        font-size: .82rem;
        font-weight: 600;

        text-decoration: none;

        transition:
            background .3s ease,
            transform .3s ease;

        &:hover {
            background: var(--primary-hover);

            transform: translateY(-2px);
        }
    }
}

@media (min-width: 768px) {
    .visit {
        min-height: 350px;

        background-position: center center;

        .container {
            max-width: 1200px;

            padding: 0 20px;
        }

        &__content {
            max-width: 420px;
        }

        &__title {
            font-size: 3.1rem;
        }

        &__text {
            font-size: 1.05rem;
        }
    }
}
</style>